import styled from 'styled-components'

export const CatalogItemDetailsPanelStyled = styled.div`
  flex: 0 1 ${(props) => props.theme.typography.pxToRem(480)};
  min-width: 0;
  display: flex;
  border-left: 1px solid
    ${(props) => props.theme.colors.content.secondaryBorder};
`
